import { render, staticRenderFns } from "./CardDatas.vue?vue&type=template&id=9ed53886&"
import script from "./CardDatas.vue?vue&type=script&lang=js&"
export * from "./CardDatas.vue?vue&type=script&lang=js&"
import style0 from "./CardDatas.vue?vue&type=style&index=0&id=9ed53886&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports